const CATEGORY_LABELS: Record<string, string> = {
  stockItem: 'Skladová položka',
  service: 'Služba',
  payment: 'Platby',
  ReceivedPayment: 'Platby',
  client: 'Klient',
  visit: 'Návštěva',
  procedure: 'Postup',
  stock: 'Sklad',
  invoice: 'Faktura',
  subscription: 'Předplatné',
  user: 'Uživatel',
  team: 'Tým',
  smsTemplate: 'SMS šablona',
};

export const getLogCategoryLabel = (category: string) => CATEGORY_LABELS[category] ?? category;

const ACTION_LABELS: Record<string, string> = {
  create: 'Vytvoření',
  update: 'Úprava',
  delete: 'Smazání',
  PAYMENT_MATCHED: 'Platba spárována',
  PAYMENT_RECEIVED: 'Platba přijata',
  purchase: 'Nákup',
};

export const getLogActionLabel = (action: string) =>
  ACTION_LABELS[action] ?? action.replace(/[_-]/g, ' ');
